import { CanMatchFn, UrlSegment } from '@angular/router';

function isAdministrativePrefix(segments: UrlSegment[]): boolean {
  return (segments[0]?.path || '').toLowerCase() === 'administration';
}

export const nonAdminPrefixGuard: CanMatchFn = (_route, segments) => {
  return !isAdministrativePrefix(segments);
};
